import { render, staticRenderFns } from "./TransactionsTable.vue?vue&type=template&id=acccad34&"
import script from "./TransactionsTable.vue?vue&type=script&lang=js&"
export * from "./TransactionsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports